import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const ADD_BANNER = "banner/create";
const DELETE_BANNER = "banner/delete";
const GET_BANNER = "banner/getall";
const UPDATE_BANNER = "banner/update";
const UPDATE_BANNER_POSITION = "banner/update-position";

const ADD_SECTION = "main/create";
const DELETE_SECTION = "main/delete";
const GET_SECTION = "main/getall";
const UPDATE_SECTION = "main/update";

export default {
  add_banner(payload) {
    return Repository.post(transformRoute(ADD_BANNER), payload);
  },
  delete_banner(payload) {
    return Repository.post(transformRoute(DELETE_BANNER), payload);
  },
  getall_banner(payload) {
    return Repository.get(transformRoute(GET_BANNER), { params: payload });
  },
  update_banner(payload) {
    return Repository.post(transformRoute(UPDATE_BANNER), payload);
  },
  update_banner_position(payload) {
    return Repository.post(transformRoute(UPDATE_BANNER_POSITION), payload);
  },

  ////////////////////////
  ////////////////////////

  add_aboutUs(payload) {
    return Repository.post(transformRoute(ADD_SECTION), payload);
  },
  delete_aboutUs(payload) {
    return Repository.post(transformRoute(DELETE_SECTION), payload);
  },
  getall_aboutUs(payload) {
    return Repository.get(transformRoute(GET_SECTION), { params: payload });
  },
  update_aboutUs(payload) {
    return Repository.post(transformRoute(UPDATE_SECTION), payload);
  },
};

const transformRoute = (route) => {
  return `aboutUs/${route}`;
};
